import { IAppState } from '../../redux';

export function selectActiveServiceId(state: IAppState): string | null {
  const {
    publishTerms: { selectedServiceId },
  } = state;

  return selectedServiceId;
}
